import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  fetchMerchantTemplate,
  listAllTemplates,
  updateMerchantTemplate,
} from "../../../utils/requests-v2";
import { useAuth } from "../../../utils/Contexts/V2/AuthenticationContext";
import { useProductPhotosContext } from "../../../utils/Contexts/V2/ProductPhotosContext";

const useTemplate = () => {
  const { user } = useAuth();
  const [isUpdating, setIsUpdating] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { productCategories } = useProductPhotosContext();

  const handleUpdateTemplate = async (callback) => {
    if (
      selectedTemplate &&
      selectedTemplate.name === "commerce" &&
      productCategories.length === 0
    ) {
      toast.error(
        "Please add at least one product and one product category before updating to the commerce template.",
        { duration: 7000 }
      );
      return;
    }
    setIsUpdating(true);
    try {
      await updateMerchantTemplate(user?.subdomain, selectedTemplate?.id);
      toast.success("Template updated successfully");
      callback();
    } catch (error) {
      toast.error("Failed to update template");
      console.error(error);
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await listAllTemplates();
        setTemplates(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    const getSelectedTemplate = async () => {
      try {
        const response = await fetchMerchantTemplate(user?.subdomain);
        setSelectedTemplate(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTemplates();
    getSelectedTemplate();
  }, []);

  return {
    isUpdating,
    templates,
    setTemplates,
    selectedTemplate,
    setSelectedTemplate,
    handleUpdateTemplate,
  };
};

export default useTemplate;
